import { toNumber } from 'lodash';

import { EligibleExpense } from '../../FileScan/fileScan.types';

import { getTheNumberOfMatches } from './getTheNumberOfMatches';

export const sortExpensesByObject = (eligibleExpenses?: EligibleExpense[], filterByValues?: object) => {
  if (!eligibleExpenses?.length) {
    return [];
  }

  const eligibleExpensesWithNumberOfMatches = eligibleExpenses.map((expense) =>
    getTheNumberOfMatches(expense, filterByValues)
  );

  return [...eligibleExpensesWithNumberOfMatches].sort((prev, next) => {
    if (prev.numberOfMatches === next.numberOfMatches) {
      return toNumber(next.expense.amount || 0) - toNumber(prev.expense.amount || 0);
    } else {
      return prev.numberOfMatches < next.numberOfMatches ? 1 : -1;
    }
  });
};
